export const generateExternalStyle = () => ({
  showReturnButton: true,
})
